import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import Player from '@vimeo/player';
import { Subject } from 'rxjs';

import { VideoFormat } from '../../types/video';

@Component({
  selector: 'liv-serie-video',
  templateUrl: './serie-video.component.html',
  styleUrls: ['./serie-video.component.scss'],
  standalone: false
})
export class SerieVideoComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('iframe', { static: false })
  iFrameElement: ElementRef<HTMLIFrameElement>;
  player: Player;

  @Input() titulo: string;
  @Input() videos: VideoFormat[];

  videoPlaying:
    | (Pick<VideoFormat, 'id' | 'titulo'> & {
        securityUrl: SafeResourceUrl;
      })
    | undefined;
  checkControl: UntypedFormControl;
  legendLabel: string;

  private destroy$ = new Subject<boolean>();
  private iFrameTimeoutRef: NodeJS.Timeout;

  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    if (this.videos?.length > 0) {
      const [video] = this.videos;
      this.forceUpdateVideoPlaying(video);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();

    if (this.player) {
      this.player.destroy();
    }

    clearTimeout(this.iFrameTimeoutRef);
  }

  ngAfterViewInit(): void {
    this.iFrameTimeoutRef = setTimeout(() => {
      const iframe = this.iFrameElement.nativeElement;

      this.player = new Player(iframe);

      this.player.on('pause', (event) => {
        console.log('pause', event);
      });
      this.player.on('play', (event) => {
        console.log('play', event);
      });
    }, 250);
  }

  forceUpdateVideoPlaying(video: VideoFormat): void {
    if (this.videoPlaying?.id !== video.id) {
      this.videoPlaying = {
        id: video.id,
        titulo: video.titulo,
        securityUrl: this.sanitizer.bypassSecurityTrustResourceUrl(video.link)
      };
    }
  }
}
